import './uploader.scss';

import qq from 'fine-uploader';
import { tryParseJSON } from './../../utilities/js/helper';

class Uploader {
    constructor ($upload, options) {
        const settings = {
            initAttr: 'data-uploader',
            requestAttr: 'data-request',
            listAttr: 'data-list',
            deleteAttr: 'data-delete',
            acceptAttr: 'data-accept',
            maxSizeAttr: 'data-maxsize',
            messagesAttr: 'data-uploader-messages'
        };

        this.settings = Object.assign({}, settings, options);

        this.$uploader = $upload;
        this.requestEndpoint = this.$uploader.getAttribute(this.settings.requestAttr);
        this.listEndpoint = this.$uploader.getAttribute(this.settings.listAttr);
        this.deleteEndpoint = this.$uploader.getAttribute(this.settings.deleteAttr);
        this.acceptFiles = this.$uploader.getAttribute(this.settings.acceptAttr);
        this.maxSize = this.$uploader.getAttribute(this.settings.maxSizeAttr);
        this.messages = this.$uploader.getAttribute(this.settings.messagesAttr);

        if (this.requestEndpoint && this.listEndpoint && this.deleteEndpoint && this.acceptFiles && this.maxSize) {
            this.initialize();
        }
    }

    initialize () {
        if (this.messages) {
            this.messages = tryParseJSON(this.messages);
        }

        const merge = (current, updates) => {
            if (current) {
                for (const key of Object.keys(updates)) {
                    if (!Object.prototype.hasOwnProperty.call(current, key) || typeof updates[key] !== 'object') current[key] = updates[key];
                    else merge(current[key], updates[key]);
                }
                return current;
            }
        };

        const options = {
            // debug: true,
            element: this.$uploader,
            validation: {
                acceptFiles: this.acceptFiles,
                sizeLimit: this.maxSize
            },
            request: {
                endpoint: this.requestEndpoint
            },
            deleteFile: {
                enabled: true,
                forceConfirm: true,
                endpoint: this.deleteEndpoint
            },
            session: {
                endpoint: this.listEndpoint
            },
            retry: {
                showAutoRetryNote: false
            },
            dropZoneElements: [this.$uploader.querySelector('.qq-upload-button-selector')],
            template: 'qq-template',
            failedUploadTextDisplay: {
                mode: 'custom',
                responseProperty: 'error'
            },
            callbacks: {
                onCancel: () => {
                    this.$uploader.classList.remove('has--error');
                },
                onDelete: () => {
                    this.$uploader.classList.remove('has--error');
                },
                onError: () => {
                    this.$uploader.classList.add('has--error');
                }
            }
        };

        let settings = options;
        if (this.messages) {
            settings = merge(options, this.messages);
        }

        this.uploader = new qq.FineUploader(settings);
    }

    setEvents () {
    }
}

export { Uploader };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$uploader = $context.querySelectorAll('[data-uploader="root"]');
        for (let i = 0; i < $$uploader.length; i++) {
            const $uploader = $$uploader[i];

            const uploaderAPI = new Uploader($uploader);
            $uploader.API = uploaderAPI;
        }
    }
});
